// src/Pages/ReferralInstructions.js
import React from "react";
import { Link } from "react-router-dom";
import "./FAQ.css";
import referralRequestImg from "../../assets/referral-request.png";

export default function ReferralInstructions() {
  return (
    <div className="faq-container">
      <h2 className="faq-heading">Referral Instructions</h2>
      <p className="faq-text">
        Earn rewards by requesting and sharing your referral code:
      </p>
      <ol className="faq-steps">
        <li className="faq-step-item">Create an account at itiniri.app/auth</li>

        <li className="faq-step-item">
          Click <strong>Become an Affiliate</strong> in the Header.
        </li>
        <li className="faq-step-item">
          Enter your name, social media to confirm your identity, a brief
          request message, your Venmo account, and your email.
        </li>
        <li className="faq-step-item">
          Click <strong>Submit Affiliate Request</strong>
        </li>
        <img
          src={referralRequestImg}
          alt="Descriptive text"
          className="faq-image"
        />
        <li className="faq-step-item">
          Once your request is accepted, you will receive a{" "}
          <strong>Referral Code</strong> on your Dashboard.
        </li>
        <li className="faq-step-item">
          Share this code with Event hosts or managers. If they create an
          account with your code, you will recieve 20% of the payment recieved
          for that event once they publish.
        </li>
      </ol>
      <Link to="/faq" className="faq-back-link">
        ← Back to FAQ
      </Link>
    </div>
  );
}
